<template>
  <div class="dosage-info">
    <div class="search-box">
      <!-- 统计时间 -->
      <div class="item">
        <span>统计时间</span>
        <div class="item-content">
          <el-date-picker
            v-model="searchForm.createTime"
            size="small"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 220px"
            @change="getList"
          >
          </el-date-picker>
        </div>
      </div>

      <!-- 剂型 -->
      <div class="item" v-if="routeQuery.type == 1">
        <span>剂型</span>
        <div class="item-content">
          <el-select v-model="searchForm.drug_type" size="small" clearable>
            <el-option
              v-for="(item, index) in drugOptions"
              :key="index"
              :label="item.drug_type_name"
              :value="item.drug_type"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- 用量类型 -->
      <div class="item">
        <span>用量类型</span>
        <div class="item-content">
          <el-select v-model="searchForm.level_type" size="small" clearable>
            <el-option
              v-for="(item, index) in levelTypeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- 用量 -->
      <div class="item">
        <span>用量</span>
        <div class="item-content">
          <el-select v-model="searchForm.use_level" size="small" clearable>
            <el-option
              v-for="(item, index) in useLevelOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          size="small"
          style="margin-left: 20px"
          @click="getList"
          >查询</el-button
        >
        <el-button size="small" @click="restBtn">重置</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1182') : false
          "
          @click="exportExcel"
          >导出excel</el-button
        >
      </div>
    </div>
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%; min-width: 1000px"
      :header-cell-style="{ background: '#F5F5F5' }"
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="item in tableHeader"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop == 'serial_number'">
            {{
              scope.row["pre_id"] ? scope.row["pre_id"] : scope.row["order_sn"]
            }}
          </div>

          <div v-else-if="item.prop == 'send_time'">
            {{ scope.row[item.prop] | dateFormat }}
          </div>

          <div v-else-if="item.prop == 'type'">
            {{ scope.row[item.prop] | typeText }}
          </div>

          <div v-else-if="item.prop == 'is_national_standard'">
            {{ !scope.row.is_national_standard ? "否" : "是" }}
          </div>

          <div v-else>
            {{
              JSON.stringify(scope.row[item.prop]) === "null"
                ? ""
                : scope.row[item.prop]
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.pre_id || scope.row.order_sn"
            type="text"
            @click="toDetails(scope.row)"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('481') : false
            "
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="totalNum > 0"
      :total="totalNum"
      :page.sync="pagination.page"
      :limit.sync="pagination.pageNumber"
      @pagination="getList"
    />
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import hospital from "@/api/hospital.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        createTime: [],
        drug_type: "",
        level_type: "",
        use_level: "",
        orderby: "",
      },
      tableLoading: false,
      tableHeader: [
        {
          label: "处方号/订单号",
          prop: "serial_number",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "用量类型",
          prop: "type",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "剂型",
          prop: "drug_type_name",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "用量",
          prop: "item_use_level",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "是否新标用量",
          prop: "is_national_standard",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
        {
          label: "统计时间",
          prop: "send_time",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: "custom",
        },
        {
          label: "备注",
          prop: "remark",
          width: "auto",
          align: "center",
          fixed: false,
          sortable: false,
        },
      ],
      tableData: [],
      drugOptions: [],
      levelTypeOptions: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "发货",
          value: 1,
        },
        {
          label: "校正",
          value: 2,
        },
      ],
      useLevelOptions: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "正校正",
          value: 1,
        },
        {
          label: "负校正",
          value: 2,
        },
      ],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    typeText(val) {
      switch (Number(val)) {
        case 0:
          return "全部";
        case 1:
          return "发货";
        case 2:
          return "校正";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    if (this.routeQuery.type == 1) {
      this.getHospitalDrugName();
    }
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.searchForm.createTime = [start, end];
    },
    getHospitalDrugName() {
      let params = {
        hospital_id: this.routeQuery.hospital_id,
      };
      hospital.getHospitalDrugName(params).then((res) => {
        let { data } = res;
        this.drugOptions = data;
      });
    },
    getList() {
      this.tableLoading = true;
      let { drug_id, hospital_id, drug_type_pid, drug_type } = this.routeQuery;
      let infoData = {
        drug_id,
        hospital_id: hospital_id ? hospital_id : 0,
        drug_type_pid: drug_type_pid ? drug_type_pid : 0,
      };
      let params = Object.assign(
        {},
        this.pagination,
        this.searchForm,
        infoData
      );
      if (this.routeQuery.type != 1) {
        params.drug_type = drug_type;
      }
      params = _.omit(params, ["createTime"]);
      let create_time = this.searchForm.createTime;
      params["create_time_start"] = create_time ? create_time[0] : "";
      params["create_time_end"] = create_time ? create_time[1] : "";
      hospital
        .goodsCorrectDetail(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.tableData = data.list;
            this.totalNum = data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    restBtn() {
      for (let key in this.searchForm) {
        this.searchForm[key] = "";
      }
      this.getList();
    },
    sortChange(value) {
      let { order, prop } = value;
      //升序
      if (order == "ascending") {
        this.searchForm.orderby = 1;
      }
      //降序
      if (order == "descending") {
        this.searchForm.orderby = 2;
      }
      if (!order) {
        this.searchForm.orderby = "";
      }
      this.getList();
    },
    exportExcel() {
      const loading = this.$loading();
      let { drug_id, hospital_id, drug_type_pid, drug_type } = this.routeQuery;
      let infoData = {
        drug_id,
        hospital_id: hospital_id ? hospital_id : 0,
        drug_type_pid: drug_type_pid ? drug_type_pid : 0,
      };
      let params = Object.assign(
        {},
        this.pagination,
        this.searchForm,
        infoData
      );
      if (this.routeQuery.type != 1) {
        params.drug_type = drug_type;
      }
      params = _.omit(params, ["createTime"]);
      let create_time = this.searchForm.createTime;
      params["create_time_start"] = create_time ? create_time[0] : "";
      params["create_time_end"] = create_time ? create_time[1] : "";
      console.log(params);
      hospital
        .goodsCorrectDetailExport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            location.href = host;
            this.$message.success("导出成功");
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    toDetails(row) {
      let { pre_id, order_sn, order_id } = row;
      console.log(row);
      if (order_id == "" || !order_id) {
        this.$message.warning("当前订单号不存在");
        return;
      }
      let path = "";
      let query = {};
      if (pre_id) {
        path = "/home/yewu/chufangdetail";
        query.pre_id = pre_id;
      }
      if (order_sn) {
        path = "/home/order/orderdetail";
        query.order_id = order_id;
      }
      this.$router.push({
        path,
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dosage-info {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 6px;
        text-align: right;
        white-space: nowrap;
      }
    }
    .item-content {
      width: 100%;
      display: flex;
      align-items: center;
      .el-input {
        width: 200px;
      }
      .el-input__inner {
        width: 100px;
      }
      .el-date-editor {
        width: 200px;
      }
      .el-select {
        width: 200px;
      }
      .el-radio-group {
        padding-top: 4px;
      }
    }
  }
}
</style>
